/**
 * SiteFavicon
 * Applies favicon and document title from /api/(admin/)configuracoes
 * Uses shared useSiteConfig hook (handles retry + refresh on save).
 */
import { useEffect } from 'react';
import useSiteConfig from '../hooks/useSiteConfig';
import { resolveBackendImage } from '../utils/brandLogo';

const DEFAULT_FAVICON = '/favicon.ico';

function setFaviconHref(href) {
  const safeHref = href || DEFAULT_FAVICON;

  // 1. <link rel="icon"> tradicional — desktop/aba
  document
    .querySelectorAll('link[rel="icon"], link[rel="shortcut icon"]')
    .forEach((node) => node.parentNode && node.parentNode.removeChild(node));
  const link = document.createElement('link');
  link.rel = 'icon';
  link.href = `${safeHref}${safeHref.includes('?') ? '&' : '?'}_t=${Date.now()}`;
  document.head.appendChild(link);

  // 2. apple-touch-icon — usado pelo iOS quando o usuário "Adiciona à Tela
  //    de Início". Atualizado dinamicamente para casar com o favicon do
  //    município ativo (white-label) e bater visualmente com o ícone do PWA.
  document
    .querySelectorAll('link[rel="apple-touch-icon"]')
    .forEach((node) => node.parentNode && node.parentNode.removeChild(node));
  ['152x152', '192x192', '512x512'].forEach((sizes) => {
    const t = document.createElement('link');
    t.rel = 'apple-touch-icon';
    t.setAttribute('sizes', sizes);
    t.href = `${safeHref}${safeHref.includes('?') ? '&' : '?'}_t=${Date.now()}`;
    document.head.appendChild(t);
  });
}

export default function SiteFavicon() {
  const { config } = useSiteConfig();

  useEffect(() => {
    const raw = config?.favicon || config?.logo_principal;
    if (!raw) {
      setFaviconHref(DEFAULT_FAVICON);
      return;
    }
    // resolveBackendImage normaliza:
    //  - URL relativa → absoluta (com REACT_APP_BACKEND_URL atual)
    //  - URL absoluta apontando p/ outro host /api/uploads/... → re-host
    setFaviconHref(resolveBackendImage(raw));

    if (config?.slogan && !document.title.startsWith(config.slogan)) {
      document.title = `${config.slogan} | ${document.title}`;
    }
  }, [config]);

  return null;
}
